import Animate from './Animate';
export default Animate;
